<template>
    <v-container fluid>
        <v-overlay :value="pageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <div>
            <!-- Filters -->
            <ni-filters
            :search="search"
            @search="updateSearch($event)"
            ></ni-filters>
        </div>

        <div class="mt-3">
            <v-row>
                <v-col md="6">
                    <chart1
                        v-if="charts.chart1.data"
                        ref="chart1"
                        :chartData="charts.chart1.data"
                    ></chart1>
                </v-col>
                <v-col md="6">
                    <chart2 
                        v-if="charts.chart2.data"
                        ref="chart2"
                        :chartData="charts.chart2.data"
                    ></chart2>
                </v-col>
                <v-col md="6">
                    <chart3 
                        v-if="charts.chart3.data"
                        ref="chart3"
                        :chartData="charts.chart3.data"
                    ></chart3>
                </v-col>
                <v-col md="6">
                    <chart4
                        v-if="charts.chart4.data"
                        ref="chart4"
                        :chartData="charts.chart4.data"
                    ></chart4>
                </v-col>
                <v-col md="6">
                    <chart5 
                        v-if="charts.chartVal.data"
                        ref="chart5"
                        :chartData="charts.chartVal.data"
                        :rangeLabel="charts.chartVal.range"
                    ></chart5>
                    <v-container
                    fluid
                    v-if="charts.chartVal.data">
                        <v-row align="center"
                            justify="center">
                            <v-col class="text-right">
                                <v-btn
                                elevation="2"
                                @click="handleRangeFilters(charts.chartVal, 'Week');"
                                >Weekly</v-btn>
                            </v-col>
                            <v-col>
                                <v-btn
                                elevation="2"
                                @click="handleRangeFilters(charts.chartVal, 'Month');"
                                >Monthly</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col md="6">
                    <chart6
                        v-if="charts.chartVol.data"
                        ref="chart6"
                        :chartData="charts.chartVol.data"
                        :rangeLabel="charts.chartVol.range"
                    ></chart6>
                    <v-container
                    fluid
                    v-if="charts.chartVol.data">
                        <v-row align="center"
                            justify="center">
                            <v-col class="text-right">
                                <v-btn
                                elevation="2"
                                @click="handleRangeFilters(charts.chartVol, 'Week');"
                                >Weekly</v-btn>
                            </v-col>
                            <v-col>
                                <v-btn
                                elevation="2"
                                @click="handleRangeFilters(charts.chartVol, 'Month');"
                                >Monthly</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import NiFilters from '@/components/niPos/Filters.vue';

import Chart1 from '@/components/niPos/charts/NiPosChart1.vue';
import Chart2 from '@/components/niPos/charts/NiPosChart2.vue';
import Chart3 from '@/components/niPos/charts/NiPosChart3.vue';
import Chart4 from '@/components/niPos/charts/NiPosChart4.vue';
import Chart5 from '@/components/niPos/charts/NiPosChart5.vue';
import Chart6 from '@/components/niPos/charts/NiPosChart6.vue';

export default {
    components: {
        'ni-filters': NiFilters,
        'chart1': Chart1,
        'chart2': Chart2,
        'chart3': Chart3,
        'chart4': Chart4,
        'chart5': Chart5,
        'chart6': Chart6,
    },
    data() {
        return {
            search: {
                fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                toDate: new Date().toISOString().substr(0, 10)
            },

            charts: {
                chart1: {
                    data: null,
                    loading: true,
                },
                chart2: {
                    data: null,
                    loading: true,
                },
                chart3: {
                    data: null,
                    loading: true,
                },
                chart4: {
                    data: null,
                    loading: true,
                },
                chartVal: {
                    data: null,
                    range: "Month",
                    week: null,
                    month: null,
                    loading: true,
                },
                chartVol: {
                    data: null,
                    range: "Month",
                    week: null,
                    month: null,
                    loading: true,
                },
            },
            
            pageLoading: true,
            errors: [],
        }
    },

    beforeMount() {
        this.refresh();
    },
    
    methods: {
        masterReq(url, data={search: this.search}, responseType='json', method='post') {
            return axios({
                method: method,
                url: url,
                data: data,
                responseType: responseType,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
        },

        getCharts() {

            this.masterReq('get-chart-1-live-ni-pos').then((response) => {
                this.charts.chart1.data = response.data;
                this.charts.chart1.loading = false;
                this.updatePageLoading();
            })
            .catch(e => {
                this.pageLoading = false;
                this.errors.push(e);
            });

            this.masterReq('get-chart-2-live-ni-pos').then((response) => {
                this.charts.chart2.data = response.data;
                this.charts.chart2.loading = false;
                this.updatePageLoading();
            })
            .catch(e => {
                this.pageLoading = false;
                this.errors.push(e);
            });

            this.masterReq('get-chart-3-live-ni-pos').then((response) => {
                this.charts.chart3.data = response.data;
                this.charts.chart3.loading = false;
                this.updatePageLoading();
            })
            .catch(e => {
                this.pageLoading = false;
                this.errors.push(e);
            });

            this.masterReq('get-chart-4-live-ni-pos').then((response) => {
                this.charts.chart4.data = response.data;
                this.charts.chart4.loading = false;
                this.updatePageLoading();
            })
            .catch(e => {
                this.pageLoading = false;
                this.errors.push(e);
            });

            this.masterReq('get-chart-valvol-live-ni-pos').then((response) => {
                var charts = this.charts;
                var chartData = response.data;

                console.log("valVol:", chartData);

                var week = JSON.parse(chartData['Week'][0].chartJson);
                var month = JSON.parse(chartData['Month'][0].chartJson);

                charts.chartVal.week = week.valChart;
                charts.chartVal.month = month.valChart;

                charts.chartVol.week = week.volChart;
                charts.chartVol.month = month.volChart;
                
                this.updateChartData(charts.chartVal);
                this.updateChartData(charts.chartVol);

                this.charts.chartVal.loading = false;
                this.charts.chartVol.loading = false;
                this.updatePageLoading();
            })
            .catch(e => {
                this.pageLoading = false;
                this.errors.push(e);
            });
        },

        handleRangeFilters(chart, range) {
            chart.range = range;
            this.updateChartData(chart);
        },

        updateChartData(chart) {
            if (chart.range == 'Week') {
                chart.data = chart.week;
            } else {
                chart.data = chart.month;
            }
        },

        updateSearch(e) {
            this.search = e;
            this.refresh();
        },

        updatePageLoading() {
            var charts = this.charts;
            this.pageLoading = charts.chart1.loading || charts.chart2.loading || charts.chart3.loading || charts.chart4.loading || charts.chartVal.loading || charts.chartVol.loading;
        },

        refresh() {
            console.log("refresh");
            this.pageLoading = true;
            this.getCharts();
        },
    }
}
</script>